const storage = {
    set(name, value) {
        try {
            localStorage.setItem(name, value);
        } catch {
            try {
                sessionStorage.setItem(name, value);
            } catch (e) {
                console.log(e);
            }
        }
    },
    get(name) {
        let res;
        try {
            res = JSON.parse(localStorage.getItem(name));
        } catch {
            try {
                res = JSON.parse(sessionStorage.getItem(name));
            } catch (e) {
                console.log(e);
            }
        }
        return res;
    },
};